import * as yup from 'yup';
import { commentSchema } from 'utils/schemas/comment.schema';

export const schema = yup.object().shape({
  dislikeComment: commentSchema.required('validationErrors.comment.min'),
});
